import { Flash } from "iconsax-reactjs";

const PoweredByAITag = () => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "10px 14px",
        border: "1px solid #E2E8F0",
        borderRadius: 8,
        background:
          "linear-gradient(94.42deg, rgba(255,255,255,0), rgba(255,255,255,0.2))",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 14,
        fontWeight: 600,
      }}
    >
      <Flash size={20} variant="Bold" color="#2563EB" />
      <span
        style={{
          background: "linear-gradient(90deg, #2563eb, #4fd1c5)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Powered by 6EL∆
      </span>
    </div>
  );
};

export default PoweredByAITag;
